<template>
	<div>
		<el-divider>{{ keytype.ktid ? '修改' : '添加' }}优化词分组</el-divider>
		<el-form class="text-left" ref="typeForm" :rules="rules" :model="keytype" style="width: 80%;margin: 0 auto;">
			<el-form-item label="优化词分组名称" :label-width="formLabelWidth" prop="keytypename">
				<el-input v-model="keytype.keytypename" autocomplete="off" placeholder="请输入优化词分组名称,长度2-50个字符"></el-input>
			</el-form-item>
			<el-form-item label="所属模型" :label-width="formLabelWidth" prop="mid">
				<el-select v-model="keytype.mid" placeholder="请选择模型">
					<el-option v-for="(item, index) in mlist" :key="index" :label="item.modelname" :value="item.mid"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="关键字列表" :label-width="formLabelWidth" prop="keywordlist">
				<el-input placeholder="请输入关键字列表,长度2-180位的任意字符" v-model="keytype.keywordlist">
					<template slot="append">
						<el-button type="warning" icon="el-icon-s-promotion" @click="showDialog">选择SEO优化词</el-button>
					</template>
				</el-input>
			</el-form-item>
			<el-form-item label="网页简介" :label-width="formLabelWidth" prop="description">
				<el-input
					type="textarea"
					v-model="keytype.description"
					:rows="4"
					autocomplete="off"
					:autosize="{ minRows: 4, maxRows: 8 }"
					placeholder="请输入关键字列表,长度2-250位的任意字符"
				></el-input>
			</el-form-item>
		</el-form>
		<div style="margin-bottom: 15px;">
			<el-button type="primary" @click="submitForm('typeForm')">确定保存</el-button>
			<el-button type="default" @click="turnback">取消添加</el-button>
		</div>
		<el-dialog title="SEO优化词列表" :visible.sync="dialogVisible" width="80%" :close-on-click-modal="false">
			<el-button-group>
				<el-button type="primary" size="mini" icon="el-icon-select" @click="selectAll">全选</el-button>
				<el-button type="warning" size="mini" icon="el-icon-select" @click="selectDiff">反选</el-button>
			</el-button-group>
			<el-dropdown trigger="click">
				<el-button type="primary" icon="el-icon-setting" size="mini">
					筛选
					<i class="el-icon-arrow-down el-icon--right"></i>
				</el-button>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item v-for="(items, index) in filtrateList" :key="index">
						<el-dropdown trigger="hover" placement="right-start" @command="seleCommand">
							<el-button type="text" icon="el-icon-caret-right" size="mini">{{ items.label }}</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item
									icon="el-icon-caret-right"
									v-for="(item, key) in items.seconds"
									:key="key"
									:command="{ indexa: index, indexb: key, param: items.paramValue, paramval: item.val }"
									:class="item.checked ? 'color-blue' : ''"
								>
									{{ item.label }}
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<el-button type="warning" size="mini" icon="el-icon-refresh">刷新</el-button>
			<el-button v-if="selectedKeywordIds.length" type="success" size="mini" icon="el-icon-check" @click="chooseSeoKeyword">确认选择</el-button>
			<el-table
				ref="multipleTable"
				:data="keywordList"
				style="width: 100%;margin-bottom: 20px;"
				row-key="kid"
				:stripe="true"
				:default-sort="{ prop: 'ctime', order: 'ascending' }"
				@sort-change="sortChange"
				@selection-change="selectChange"
				tooltip-effect="dark"
			>
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column prop="kid" label="序号" width="80" sortable></el-table-column>
				<el-table-column prop="mid" label="所属模型">
					<template slot-scope="scope">
						{{ mlist[scope.row.mid].modelname }}
					</template>
				</el-table-column>
				<el-table-column prop="keywordname" label="SEO优化词名称" show-overflow-tooltip></el-table-column>
				<el-table-column prop="hit" label="查阅次数" show-overflow-tooltip></el-table-column>
				<el-table-column prop="mid" label="链接类型">
					<template slot-scope="scope">
						{{ ['内链', '外链'][scope.row.islink] }}
					</template>
				</el-table-column>
				<el-table-column prop="istop" label="热门关键词">
					<template slot-scope="scope">
						<i :class="scope.row.istop ? 'el-icon-check color-green' : 'el-icon-close color-red'"></i>
					</template>
				</el-table-column>
			</el-table>
			<div class="block">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="thispage"
					:page-sizes="pageSizes"
					:page-size="pagesize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	name: 'addLink',
	data() {
		return {
			mlist: [], //模型列表
			keytype: {
				ktid: '',
				mid: '',
				keytypename: '',
				keywordlist: '', //优化词列表
				description: '' //分组介绍
			},
			extrawords: [],
			rules: {
				keytypename: [{ required: true, message: '请输入优化词分组', trigger: 'blur' }, { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }],
				mid: [{ required: true, message: '请选择所属模型', trigger: 'blur' }],
				keywordlist: [{ required: true, message: '请输入关键词列表', trigger: 'blur' }, { min: 2, max: 180, message: '长度在 2 到 50 个字符', trigger: 'blur' }],
				description: [{ min: 2, max: 250, message: '长度在 2 到 250 个字符', trigger: 'blur' }]
			},
			formLabelWidth: '130px',
			dialogVisible: false,
			keywordList:[],
			sort_param: '', //排序字段
			sort_type: '', //排序方式ascending = asc;descending = desc,'' = asc;
			thispage: 1,
			total: 0,
			pagesize: 10, //每页显示条数
			pageSizes: [10, 15, 20, 30], //每页显示个数选择器
			filtrateList:[
				{
					label: '所属模型',
					paramValue: 'mid',
					seconds: [
						{
							val: '',
							label: '全部',
							checked: true
						}
					]
				}
			],
			selectParams: [],
			selectedKeywordIds: [],
		};
	},
	mounted() {
		let query = this.$route.query;
		if (query.ktid) {
			this.keytype.ktid = query.ktid;
		}
		this.getModelList();
	},
	methods: {
		// 返回
		turnback() {
			this.$router.go(-1);
		},
		// 获取模型列表
		getModelList() {
			this.$axios({
				url: this.HOST + '/admin.seo/getModelList',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.mlist = res.data;
						for(let i in this.mlist){
							this.filtrateList[0].seconds.push({
								val:this.mlist[i].mid,
								label:this.mlist[i].modelname
							})
						}
						if (this.$route.query.ktid) {
							this.getLinkTypeInfo(this.$route.query.ktid);
						}
					}
				})
				.catch(err => {});
		},
		//获取优化词分组内容
		getLinkTypeInfo(ktid) {
			this.$axios({
				url: this.HOST + '/admin.seo/getLinkTypeInfo',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					ktid: ktid
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.keytype = res.data;
					}
				})
				.catch(err => {});
		},
		// 提交前验证
		submitForm(ruleform) {
			console.log(this.keytype);
			this.$refs[ruleform].validate((valid, attr) => {
				if (valid) {
					this.addKeyLinkType();
				} else {
					console.log('error submit!!', attr);
					return false;
				}
			});
		},
		//添加修改分组
		addKeyLinkType() {
			this.$axios({
				url: this.HOST + '/admin.seo/addKeyLinkType',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					keytype: this.keytype
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.$message.success(res.data.msg);
						this.$router.go(-1);
					}
				})
				.catch(err => {});
		},
		//每页分页条数修改
		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
			this.pagesize = val;
			this.getKeywordList();
		},
		//当前页码翻页
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.thispage = val;
			this.getKeywordList();
		},
		//优化词排序查询
		sortChange({ column, prop, order }) {
			console.log(column, prop, order);
			this.sort_param = prop;
			this.sort_type = order == 'descending' ? 'desc' : 'asc';
			this.getKeywordList();
		},
		showDialog(){
			this.dialogVisible = true;
			this.thispage = 1;
			this.getKeywordList();
		},
		//查询优化词列表
		getKeywordList(firstLoad = 0) {
			this.selectedKeywordIds = [];//初始化选中值
			console.log(this.selectParams);
			let separ = [];
			for(let i in this.selectParams){
				console.log(i,this.selectParams[i]);
				separ.push({param:i,paramVal:this.selectParams[i]});
			}
			this.$axios({
				url: this.HOST + '/admin.seo/keywordList',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					thispage: this.thispage,
					pagesize: this.pagesize,
					sort_param: this.sort_param,
					sort_type: this.sort_type,
					firstLoad: firstLoad,
					selectParams:separ
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.keywordList = res.data.data;
						this.total = res.data.total;
					}
				})
				.catch(err => {});
		},
		//优化词选中列表变动
		selectChange(selection) {
			let arr = [];
			for (let i in selection) {
				arr.push(selection[i].kid);
			}
			this.selectedKeywordIds = arr;
			console.log(this.selectedKeywordIds);
		},
		//优化词查询条件变动
		seleCommand(command) {
			console.log('sele:', command);
			this.selectParams[command.param] = command.paramval;
			this.filtrateList[command.indexa].seconds.map(item => {
				this.$set(item, 'checked', false);
			});
			this.filtrateList[command.indexa].seconds[command.indexb].checked = true;
			console.log(this.selectParams);
			this.getKeywordList();
		},
		// 优化词全选
		selectAll() {
			this.keywordList.map(item => {
				this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
			});
			// this.selectedKeywordIds = this.docIds;
		},
		// 优化词反选
		selectDiff() {
			let diff = [];
			this.keywordList.map(item => {
				if (this.selectedKeywordIds.indexOf(item.kid) != -1) {
					this.$refs.multipleTable.toggleRowSelection(item, false); //切换该子节点选中状态
				} else {
					diff.push(item.kid);
					this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
				}
			});
			this.selectedKeywordIds = diff;
			console.log(this.selectedKeywordIds);
		},
		chooseSeoKeyword(){
			let words = [];
			this.keywordList.map(item=>{
				if(this.selectedKeywordIds.indexOf(item.kid) != -1){
					words.push(item.keywordname);
				}
			})
			this.dialogVisible = false;
			this.selectedKeywordIds = [];//初始化
			if(this.keytype.keywordlist){
				this.keytype.keywordlist += ',' + words.join(',');
			}else{
				this.keytype.keywordlist = words.join(',');
			}
		}
	}
};
</script>
<style lang="scss">
.el-button + .el-button-group {
	margin-left: 10px;
	margin-right: 10px;
}
.el-form-item {
	margin-bottom: 20px;
}
.el-alert {
	display: inline;
	.el-alert__content {
		line-height: 20px;
	}
}
.word-input {
	width: calc(100% - 40px);
}
.input-delete.el-icon-delete {
	width: 20px;
	height: 20px;
	box-sizing: border-box;
	font-size: 20px;
	margin-top: 10px;
	margin-left: 10px;
	&:hover {
		color: #458efc;
		cursor: pointer;
	}
}
</style>
